import Box from "ui/atom/Box";
import Button from "ui/base/Button";


export default function Actions({ actions, ...props }) {
	return (
		<Box.Column gap={1} {...props}>
			{actions.map(({ hide, ...action }, index) => {
				if (hide) return null;
				return (
					<Button key={index} fullWidth {...action}>
						{action.label}
					</Button>
				);
			}
			)}
		</Box.Column>
	);
}